import script from "./ElencoPreventivi.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoPreventivi.vue?vue&type=script&setup=true&lang=js"

import "./ElencoPreventivi.vue?vue&type=style&index=0&id=60befe43&lang=css"

const __exports__ = script;

export default __exports__